const BAPLIE_SYNC_STATUSES = {
  COMPLETED: 1,
  PARSER_FAILED: 4,
  PENDING: 0,
  SKIPPED: 2,
  SKIPPED_PORT_CALL_CLOSED: 3,
}

export const BAPLIE_SYNC_STATUS_KEYS = {
  [BAPLIE_SYNC_STATUSES.PENDING]:
    'portCall.shipOverview.baplieOrRestowInfo.syncPending',
  [BAPLIE_SYNC_STATUSES.COMPLETED]:
    'portCall.shipOverview.baplieOrRestowInfo.syncCompleted',
  [BAPLIE_SYNC_STATUSES.SKIPPED]:
    'portCall.shipOverview.baplieOrRestowInfo.syncSkipped',
  [BAPLIE_SYNC_STATUSES.SKIPPED_PORT_CALL_CLOSED]:
    'portCall.shipOverview.baplieOrRestowInfo.syncSkipped',
  [BAPLIE_SYNC_STATUSES.PARSER_FAILED]:
    'portCall.shipOverview.baplieOrRestowInfo.syncParserFailed',
}

export default BAPLIE_SYNC_STATUSES
